import styled from "styled-components";

export const LargeParagraph = styled.p`
  max-width: 800px;
  margin: 2rem;
  text-align: left;
`;
